
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("ilE0W", function(module, exports) {

$parcel$export(module.exports, "Dialog", function () { return $d5b93a24089dc4d8$export$3ddf2d174ce01153; });
$parcel$export(module.exports, "AlertDialog", function () { return $d5b93a24089dc4d8$export$de466dd8317b0b75; });
$parcel$export(module.exports, "DialogTrigger", function () { return $d5b93a24089dc4d8$export$2e1e1122cf0cba88; });
$parcel$export(module.exports, "DialogContainer", function () { return $d5b93a24089dc4d8$export$547754aada6e339f; });
$parcel$export(module.exports, "useDialogContainer", function () { return $d5b93a24089dc4d8$export$a2f2d8fa6720dab1; });


var $beEZ9 = parcelRequire("beEZ9");

var $j951X = parcelRequire("j951X");

var $l1Yqs = parcelRequire("l1Yqs");

var $5mLCk = parcelRequire("5mLCk");

var $cYn9G = parcelRequire("cYn9G");

var $5yq5x = parcelRequire("5yq5x");

var $bDtnO = parcelRequire("bDtnO");

var $9JR01 = parcelRequire("9JR01");

var $7eprg = parcelRequire("7eprg");

var $dxdPm = parcelRequire("dxdPm");

var $fll6F = parcelRequire("fll6F");

var $ibAW5 = parcelRequire("ibAW5");

var $4O7mW = parcelRequire("4O7mW");

var $6olJd = parcelRequire("6olJd");

var $1yMrW = parcelRequire("1yMrW");

var $aCJeV = parcelRequire("aCJeV");

var $20dvM = parcelRequire("20dvM");
function $d5b93a24089dc4d8$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $d5b93a24089dc4d8$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d5b93a24089dc4d8$var$$97b119e05830ea0d$export$8b93a07348a7730c = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createContext(null);
var $d5b93a24089dc4d8$var$$f3fff851f5cc5a1e$exports = {};
var $d5b93a24089dc4d8$var$$cc8cbf248c4ac933$exports = {};
$d5b93a24089dc4d8$var$$cc8cbf248c4ac933$exports = {
    "alert": `\u{62A}\u{646}\u{628}\u{64A}\u{647}`,
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};
var $d5b93a24089dc4d8$var$$c23042f930ed2466$exports = {};
$d5b93a24089dc4d8$var$$c23042f930ed2466$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B}`,
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};
var $d5b93a24089dc4d8$var$$22339168a6e88f2f$exports = {};
$d5b93a24089dc4d8$var$$22339168a6e88f2f$exports = {
    "alert": `V\xfdstraha`,
    "dismiss": `Odstranit`
};
var $d5b93a24089dc4d8$var$$ec8dd13b968e5322$exports = {};
$d5b93a24089dc4d8$var$$ec8dd13b968e5322$exports = {
    "alert": `Advarsel`,
    "dismiss": `Luk`
};
var $d5b93a24089dc4d8$var$$39167ee9a84b7061$exports = {};
$d5b93a24089dc4d8$var$$39167ee9a84b7061$exports = {
    "alert": `Warnhinweis`,
    "dismiss": `Schlie\xdfen`
};
var $d5b93a24089dc4d8$var$$1704ee735c76afc9$exports = {};
$d5b93a24089dc4d8$var$$1704ee735c76afc9$exports = {
    "alert": `\u{395}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};
var $d5b93a24089dc4d8$var$$0cb312c2797e7a68$exports = {};
$d5b93a24089dc4d8$var$$0cb312c2797e7a68$exports = {
    "dismiss": `Dismiss`,
    "alert": `Alert`
};
var $d5b93a24089dc4d8$var$$95df037910b72a83$exports = {};
$d5b93a24089dc4d8$var$$95df037910b72a83$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};
var $d5b93a24089dc4d8$var$$9e83f2ab3a156c72$exports = {};
$d5b93a24089dc4d8$var$$9e83f2ab3a156c72$exports = {
    "alert": `Teade`,
    "dismiss": `L\xf5peta`
};
var $d5b93a24089dc4d8$var$$f0c4e76101f61910$exports = {};
$d5b93a24089dc4d8$var$$f0c4e76101f61910$exports = {
    "alert": `H\xe4lytys`,
    "dismiss": `Hylk\xe4\xe4`
};
var $d5b93a24089dc4d8$var$$0e0388177f2c7eb2$exports = {};
$d5b93a24089dc4d8$var$$0e0388177f2c7eb2$exports = {
    "alert": `Alerte`,
    "dismiss": `Rejeter`
};
var $d5b93a24089dc4d8$var$$fd928d81cf33984c$exports = {};
$d5b93a24089dc4d8$var$$fd928d81cf33984c$exports = {
    "alert": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D4}`,
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};
var $d5b93a24089dc4d8$var$$17a3672f010e4055$exports = {};
$d5b93a24089dc4d8$var$$17a3672f010e4055$exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};
var $d5b93a24089dc4d8$var$$43993547bd42ef6e$exports = {};
$d5b93a24089dc4d8$var$$43993547bd42ef6e$exports = {
    "alert": `Figyelmeztet\xe9s`,
    "dismiss": `Elutas\xedt\xe1s`
};
var $d5b93a24089dc4d8$var$$fca04de68cb5ade1$exports = {};
$d5b93a24089dc4d8$var$$fca04de68cb5ade1$exports = {
    "alert": `Avviso`,
    "dismiss": `Ignora`
};
var $d5b93a24089dc4d8$var$$0d47eca4edb370b0$exports = {};
$d5b93a24089dc4d8$var$$0d47eca4edb370b0$exports = {
    "alert": `\u{30A2}\u{30E9}\u{30FC}\u{30C8}`,
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};
var $d5b93a24089dc4d8$var$$d791c4a431b7a587$exports = {};
$d5b93a24089dc4d8$var$$d791c4a431b7a587$exports = {
    "alert": `\u{ACBD}\u{ACE0}`,
    "dismiss": `\u{BB34}\u{C2DC}`
};
var $d5b93a24089dc4d8$var$$35175b1ad320fcc1$exports = {};
$d5b93a24089dc4d8$var$$35175b1ad320fcc1$exports = {
    "alert": `\u{12E}sp\u{117}jimas`,
    "dismiss": `Atmesti`
};
var $d5b93a24089dc4d8$var$$b9d08f9d50543ce2$exports = {};
$d5b93a24089dc4d8$var$$b9d08f9d50543ce2$exports = {
    "alert": `Br\u{12B}din\u{101}jums`,
    "dismiss": `Ner\u{101}d\u{12B}t`
};
var $d5b93a24089dc4d8$var$$20889bf3c0d36a01$exports = {};
$d5b93a24089dc4d8$var$$20889bf3c0d36a01$exports = {
    "alert": `Varsel`,
    "dismiss": `Lukk`
};
var $d5b93a24089dc4d8$var$$f694e1ecd0344008$exports = {};
$d5b93a24089dc4d8$var$$f694e1ecd0344008$exports = {
    "alert": `Melding`,
    "dismiss": `Negeren`
};
var $d5b93a24089dc4d8$var$$1b424c160db5642d$exports = {};
$d5b93a24089dc4d8$var$$1b424c160db5642d$exports = {
    "alert": `Ostrze\u{17C}enie`,
    "dismiss": `Zignoruj`
};
var $d5b93a24089dc4d8$var$$5d029553257fceab$exports = {};
$d5b93a24089dc4d8$var$$5d029553257fceab$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};
var $d5b93a24089dc4d8$var$$2bea12bc13111737$exports = {};
$d5b93a24089dc4d8$var$$2bea12bc13111737$exports = {
    "alert": `Alerta`,
    "dismiss": `Dispensar`
};
var $d5b93a24089dc4d8$var$$12084690a0b76ac4$exports = {};
$d5b93a24089dc4d8$var$$12084690a0b76ac4$exports = {
    "alert": `Alert\u{103}`,
    "dismiss": `Revocare`
};
var $d5b93a24089dc4d8$var$$697f8e526692bd95$exports = {};
$d5b93a24089dc4d8$var$$697f8e526692bd95$exports = {
    "alert": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};
var $d5b93a24089dc4d8$var$$0802ec67729008c5$exports = {};
$d5b93a24089dc4d8$var$$0802ec67729008c5$exports = {
    "alert": `Upozornenie`,
    "dismiss": `Zru\u{161}i\u{165}`
};
var $d5b93a24089dc4d8$var$$ef29867297882921$exports = {};
$d5b93a24089dc4d8$var$$ef29867297882921$exports = {
    "alert": `Opozorilo`,
    "dismiss": `Opusti`
};
var $d5b93a24089dc4d8$var$$39eb6836bb014970$exports = {};
$d5b93a24089dc4d8$var$$39eb6836bb014970$exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};
var $d5b93a24089dc4d8$var$$b4fa8198ca731e89$exports = {};
$d5b93a24089dc4d8$var$$b4fa8198ca731e89$exports = {
    "alert": `Varning`,
    "dismiss": `Avvisa`
};
var $d5b93a24089dc4d8$var$$862832bdcbb90256$exports = {};
$d5b93a24089dc4d8$var$$862832bdcbb90256$exports = {
    "alert": `Uyar\u{131}`,
    "dismiss": `Kapat`
};
var $d5b93a24089dc4d8$var$$2fa80cee796b989c$exports = {};
$d5b93a24089dc4d8$var$$2fa80cee796b989c$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{442}\u{440}\u{438}\u{432}\u{43E}\u{433}\u{438}`,
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};
var $d5b93a24089dc4d8$var$$ecd80835333d83cc$exports = {};
$d5b93a24089dc4d8$var$$ecd80835333d83cc$exports = {
    "alert": `\u{8B66}\u{62A5}`,
    "dismiss": `\u{53D6}\u{6D88}`
};
var $d5b93a24089dc4d8$var$$03712eabbcfd201c$exports = {};
$d5b93a24089dc4d8$var$$03712eabbcfd201c$exports = {
    "alert": `\u{8B66}\u{793A}`,
    "dismiss": `\u{95DC}\u{9589}`
};
$d5b93a24089dc4d8$var$$f3fff851f5cc5a1e$exports = {
    "ar-AE": $d5b93a24089dc4d8$var$$cc8cbf248c4ac933$exports,
    "bg-BG": $d5b93a24089dc4d8$var$$c23042f930ed2466$exports,
    "cs-CZ": $d5b93a24089dc4d8$var$$22339168a6e88f2f$exports,
    "da-DK": $d5b93a24089dc4d8$var$$ec8dd13b968e5322$exports,
    "de-DE": $d5b93a24089dc4d8$var$$39167ee9a84b7061$exports,
    "el-GR": $d5b93a24089dc4d8$var$$1704ee735c76afc9$exports,
    "en-US": $d5b93a24089dc4d8$var$$0cb312c2797e7a68$exports,
    "es-ES": $d5b93a24089dc4d8$var$$95df037910b72a83$exports,
    "et-EE": $d5b93a24089dc4d8$var$$9e83f2ab3a156c72$exports,
    "fi-FI": $d5b93a24089dc4d8$var$$f0c4e76101f61910$exports,
    "fr-FR": $d5b93a24089dc4d8$var$$0e0388177f2c7eb2$exports,
    "he-IL": $d5b93a24089dc4d8$var$$fd928d81cf33984c$exports,
    "hr-HR": $d5b93a24089dc4d8$var$$17a3672f010e4055$exports,
    "hu-HU": $d5b93a24089dc4d8$var$$43993547bd42ef6e$exports,
    "it-IT": $d5b93a24089dc4d8$var$$fca04de68cb5ade1$exports,
    "ja-JP": $d5b93a24089dc4d8$var$$0d47eca4edb370b0$exports,
    "ko-KR": $d5b93a24089dc4d8$var$$d791c4a431b7a587$exports,
    "lt-LT": $d5b93a24089dc4d8$var$$35175b1ad320fcc1$exports,
    "lv-LV": $d5b93a24089dc4d8$var$$b9d08f9d50543ce2$exports,
    "nb-NO": $d5b93a24089dc4d8$var$$20889bf3c0d36a01$exports,
    "nl-NL": $d5b93a24089dc4d8$var$$f694e1ecd0344008$exports,
    "pl-PL": $d5b93a24089dc4d8$var$$1b424c160db5642d$exports,
    "pt-BR": $d5b93a24089dc4d8$var$$5d029553257fceab$exports,
    "pt-PT": $d5b93a24089dc4d8$var$$2bea12bc13111737$exports,
    "ro-RO": $d5b93a24089dc4d8$var$$12084690a0b76ac4$exports,
    "ru-RU": $d5b93a24089dc4d8$var$$697f8e526692bd95$exports,
    "sk-SK": $d5b93a24089dc4d8$var$$0802ec67729008c5$exports,
    "sl-SI": $d5b93a24089dc4d8$var$$ef29867297882921$exports,
    "sr-SP": $d5b93a24089dc4d8$var$$39eb6836bb014970$exports,
    "sv-SE": $d5b93a24089dc4d8$var$$b4fa8198ca731e89$exports,
    "tr-TR": $d5b93a24089dc4d8$var$$862832bdcbb90256$exports,
    "uk-UA": $d5b93a24089dc4d8$var$$2fa80cee796b989c$exports,
    "zh-CN": $d5b93a24089dc4d8$var$$ecd80835333d83cc$exports,
    "zh-TW": $d5b93a24089dc4d8$var$$03712eabbcfd201c$exports
};
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports = {};
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "buttonGroup", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9c686a975407e95c, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9c686a975407e95c = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "buttonGroup-end", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$92daf1b0113da0, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$92daf1b0113da0 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "closeButton", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$efe229eab43a9869, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$efe229eab43a9869 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "content", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a7db06668cad9adb, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a7db06668cad9adb = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "divider", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$e8c9778bf415dd08, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$e8c9778bf415dd08 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "focus-ring", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$f39a09f249340e2a, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$f39a09f249340e2a = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "footer", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$adb608be33961c98, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$adb608be33961c98 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "footer-start", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ba5cbcdd7db6a805, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ba5cbcdd7db6a805 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "header", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$38e42c68cf43b5d4, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$38e42c68cf43b5d4 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "header-end", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9ff84a8ef5e6eb7e, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9ff84a8ef5e6eb7e = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "header-start", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6e2679145d8d7578, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6e2679145d8d7578 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "heading", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$46e4a324ac90507f, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$46e4a324ac90507f = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "heading-start", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9f99175ea85abb45, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9f99175ea85abb45 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "hero", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$124049a9e3d0d4c3, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$124049a9e3d0d4c3 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "i18nFontFamily", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$8c4ee2c50c22c514, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$8c4ee2c50c22c514 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Button", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1db4cca5b4ade39a, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1db4cca5b4ade39a = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4681f3bcac39b2b1, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4681f3bcac39b2b1 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--dismissable", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9461b285d631d575, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9461b285d631d575 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--error", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6b5beff56972a3b, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6b5beff56972a3b = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--fullscreen", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$118506da5d3ee7c4, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$118506da5d3ee7c4 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--fullscreenTakeover", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5c061b2d3664fda9, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5c061b2d3664fda9 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--large", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b73c0c2fca84be2b, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b73c0c2fca84be2b = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--medium", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9b8ef443d0a67ca, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9b8ef443d0a67ca = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--noDivider", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$22425527a8943917, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$22425527a8943917 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--small", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5f2d9cc47409bd63, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5f2d9cc47409bd63 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog--warning", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4e66396adf61534f, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4e66396adf61534f = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-buttonGroup", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$570ae852861555b7, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$570ae852861555b7 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-buttonGroup--noFooter", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39dd75369bf2e830, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39dd75369bf2e830 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-closeButton", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a8494287d763a75d, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a8494287d763a75d = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-content", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$cb8eccd0f3639238, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$cb8eccd0f3639238 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-divider", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$dd7633d642d0bc1c, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$dd7633d642d0bc1c = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-footer", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$3ecb5025a06fe08f, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$3ecb5025a06fe08f = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-grid", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c03cd5e23af67ff5, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c03cd5e23af67ff5 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-header", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1e158eaa6363e131, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1e158eaa6363e131 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-header--noTypeIcon", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$141d8fd0950fea8b, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$141d8fd0950fea8b = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-heading", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$94335d73b7b209ec, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$94335d73b7b209ec = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-heading--noHeader", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ade8307239736e89, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ade8307239736e89 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-heading--noTypeIcon", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c53ac004df29b46, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c53ac004df29b46 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-hero", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$d405fb0a0231aa1a, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$d405fb0a0231aa1a = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-Dialog-typeIcon", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5beee9480fc6ff07, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5beee9480fc6ff07 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-FocusRing-ring", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4109102f950813a6, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4109102f950813a6 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-FocusRing", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$24c7f46a6e3605dd, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$24c7f46a6e3605dd = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-FocusRing--quiet", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$2927016961429360, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$2927016961429360 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-overlay", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39eed38e2296a1d6, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39eed38e2296a1d6 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-overlay--bottom--open", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a96755f239de61ee, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a96755f239de61ee = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-overlay--left--open", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a85c0c6b6cf8598c, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a85c0c6b6cf8598c = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-overlay--open", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a397eb58038aa381, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a397eb58038aa381 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-overlay--right--open", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$85aaa87e65e040bf, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$85aaa87e65e040bf = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "spectrum-overlay--top--open", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9768db7ffc1bc2, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9768db7ffc1bc2 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "typeIcon", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$7c523679e5521442, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$7c523679e5521442 = v);
$d5b93a24089dc4d8$var$$parcel$export($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports, "typeIcon-end", ()=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b050c62b00f90727, (v)=>$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b050c62b00f90727 = v);
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9c686a975407e95c;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$92daf1b0113da0;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$efe229eab43a9869;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a7db06668cad9adb;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$e8c9778bf415dd08;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$f39a09f249340e2a;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$adb608be33961c98;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ba5cbcdd7db6a805;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$38e42c68cf43b5d4;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9ff84a8ef5e6eb7e;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6e2679145d8d7578;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$46e4a324ac90507f;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9f99175ea85abb45;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$124049a9e3d0d4c3;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$8c4ee2c50c22c514;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1db4cca5b4ade39a;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4681f3bcac39b2b1;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9461b285d631d575;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6b5beff56972a3b;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$118506da5d3ee7c4;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5c061b2d3664fda9;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b73c0c2fca84be2b;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9b8ef443d0a67ca;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$22425527a8943917;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5f2d9cc47409bd63;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4e66396adf61534f;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$570ae852861555b7;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39dd75369bf2e830;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a8494287d763a75d;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$cb8eccd0f3639238;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$dd7633d642d0bc1c;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$3ecb5025a06fe08f;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c03cd5e23af67ff5;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1e158eaa6363e131;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$141d8fd0950fea8b;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$94335d73b7b209ec;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ade8307239736e89;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c53ac004df29b46;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$d405fb0a0231aa1a;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5beee9480fc6ff07;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4109102f950813a6;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$24c7f46a6e3605dd;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$2927016961429360;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39eed38e2296a1d6;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a96755f239de61ee;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a85c0c6b6cf8598c;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a397eb58038aa381;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$85aaa87e65e040bf;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9768db7ffc1bc2;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$7c523679e5521442;
var $d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b050c62b00f90727;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9c686a975407e95c = `h_OVWW_buttonGroup`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$92daf1b0113da0 = `h_OVWW_buttonGroup-end`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$efe229eab43a9869 = `h_OVWW_closeButton`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a7db06668cad9adb = `h_OVWW_content`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$e8c9778bf415dd08 = `h_OVWW_divider`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$f39a09f249340e2a = `h_OVWW_focus-ring`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$adb608be33961c98 = `h_OVWW_footer`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ba5cbcdd7db6a805 = `h_OVWW_footer-start`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$38e42c68cf43b5d4 = `h_OVWW_header`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9ff84a8ef5e6eb7e = `h_OVWW_header-end`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6e2679145d8d7578 = `h_OVWW_header-start`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$46e4a324ac90507f = `h_OVWW_heading`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9f99175ea85abb45 = `h_OVWW_heading-start`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$124049a9e3d0d4c3 = `h_OVWW_hero`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$8c4ee2c50c22c514 = `h_OVWW_i18nFontFamily`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1db4cca5b4ade39a = `h_OVWW_spectrum-Button`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4681f3bcac39b2b1 = `h_OVWW_spectrum-Dialog`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$9461b285d631d575 = `h_OVWW_spectrum-Dialog--dismissable`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$6b5beff56972a3b = `h_OVWW_spectrum-Dialog--error`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$118506da5d3ee7c4 = `h_OVWW_spectrum-Dialog--fullscreen`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5c061b2d3664fda9 = `h_OVWW_spectrum-Dialog--fullscreenTakeover`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b73c0c2fca84be2b = `h_OVWW_spectrum-Dialog--large`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9b8ef443d0a67ca = `h_OVWW_spectrum-Dialog--medium`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$22425527a8943917 = `h_OVWW_spectrum-Dialog--noDivider`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5f2d9cc47409bd63 = `h_OVWW_spectrum-Dialog--small`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4e66396adf61534f = `h_OVWW_spectrum-Dialog--warning`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$570ae852861555b7 = `h_OVWW_spectrum-Dialog-buttonGroup`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39dd75369bf2e830 = `h_OVWW_spectrum-Dialog-buttonGroup--noFooter`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a8494287d763a75d = `h_OVWW_spectrum-Dialog-closeButton`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$cb8eccd0f3639238 = `h_OVWW_spectrum-Dialog-content`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$dd7633d642d0bc1c = `h_OVWW_spectrum-Dialog-divider`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$3ecb5025a06fe08f = `h_OVWW_spectrum-Dialog-footer`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c03cd5e23af67ff5 = `h_OVWW_spectrum-Dialog-grid`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$1e158eaa6363e131 = `h_OVWW_spectrum-Dialog-header`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$141d8fd0950fea8b = `h_OVWW_spectrum-Dialog-header--noTypeIcon`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$94335d73b7b209ec = `h_OVWW_spectrum-Dialog-heading`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$ade8307239736e89 = `h_OVWW_spectrum-Dialog-heading--noHeader`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$c53ac004df29b46 = `h_OVWW_spectrum-Dialog-heading--noTypeIcon`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$d405fb0a0231aa1a = `h_OVWW_spectrum-Dialog-hero`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$5beee9480fc6ff07 = `h_OVWW_spectrum-Dialog-typeIcon`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4109102f950813a6 = `h_OVWW_spectrum-FocusRing-ring`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$24c7f46a6e3605dd = `h_OVWW_spectrum-FocusRing ${$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$4109102f950813a6}`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$2927016961429360 = `h_OVWW_spectrum-FocusRing--quiet`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$39eed38e2296a1d6 = `h_OVWW_spectrum-overlay`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a96755f239de61ee = `h_OVWW_spectrum-overlay--bottom--open`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a85c0c6b6cf8598c = `h_OVWW_spectrum-overlay--left--open`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$a397eb58038aa381 = `h_OVWW_spectrum-overlay--open`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$85aaa87e65e040bf = `h_OVWW_spectrum-overlay--right--open`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b9768db7ffc1bc2 = `h_OVWW_spectrum-overlay--top--open`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$7c523679e5521442 = `h_OVWW_typeIcon`;
$d5b93a24089dc4d8$var$$78859b019f1ff3c5$export$b050c62b00f90727 = `h_OVWW_typeIcon-end`;
let $d5b93a24089dc4d8$var$$99cd51dc4eb569f7$var$sizeMap = {
    S: "small",
    M: "medium",
    L: "large",
    fullscreen: "fullscreen",
    fullscreenTakeover: "fullscreenTakeover"
};
function $d5b93a24089dc4d8$var$$99cd51dc4eb569f7$var$Dialog(props, ref) {
    props = (0, $cYn9G.useSlotProps)(props, "dialog");
    let { type: type = "modal", ...contextProps } = (0, $7eprg.useContext)($d5b93a24089dc4d8$var$$97b119e05830ea0d$export$8b93a07348a7730c) || {};
    let { children: children, isDismissable: isDismissable = contextProps.isDismissable, onDismiss: onDismiss = contextProps.onClose, size: size, ...otherProps } = props;
    let stringFormatter = (0, $dxdPm.useLocalizedStringFormatter)(/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$f3fff851f5cc5a1e$exports));
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(otherProps);
    size = type === "popover" ? size || "S" : size || "L";
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    let gridRef = (0, $7eprg.useRef)();
    let sizeVariant = $d5b93a24089dc4d8$var$$99cd51dc4eb569f7$var$sizeMap[type] || $d5b93a24089dc4d8$var$$99cd51dc4eb569f7$var$sizeMap[size];
    let { dialogProps: dialogProps, titleProps: titleProps } = (0, $4O7mW.useDialog)((0, $5mLCk.mergeProps)(contextProps, props), domRef);
    let hasHeader = (0, $cYn9G.useHasChild)(`.${/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-header"]}`, (0, $cYn9G.unwrapDOMRef)(gridRef));
    let hasHeading = (0, $cYn9G.useHasChild)(`.${/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-heading"]}`, (0, $cYn9G.unwrapDOMRef)(gridRef));
    let hasFooter = (0, $cYn9G.useHasChild)(`.${/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-footer"]}`, (0, $cYn9G.unwrapDOMRef)(gridRef));
    let hasTypeIcon = (0, $cYn9G.useHasChild)(`.${/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-typeIcon"]}`, (0, $cYn9G.unwrapDOMRef)(gridRef));
    let slots = (0, $7eprg.useMemo)(()=>({
            hero: {
                UNSAFE_className: /*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-hero"]
            },
            heading: {
                UNSAFE_className: (0, $cYn9G.classNames)(/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports), "spectrum-Dialog-heading", {
                    "spectrum-Dialog-heading--noHeader": !hasHeader,
                    "spectrum-Dialog-heading--noTypeIcon": !hasTypeIcon
                }),
                level: 2,
                ...titleProps
            },
            header: {
                UNSAFE_className: (0, $cYn9G.classNames)(/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports), "spectrum-Dialog-header", {
                    "spectrum-Dialog-header--noHeading": !hasHeading,
                    "spectrum-Dialog-header--noTypeIcon": !hasTypeIcon
                })
            },
            typeIcon: {
                UNSAFE_className: /*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-typeIcon"]
            },
            divider: {
                UNSAFE_className: /*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-divider"],
                size: "M"
            },
            content: {
                UNSAFE_className: /*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-content"]
            },
            footer: {
                UNSAFE_className: /*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-footer"]
            },
            buttonGroup: {
                UNSAFE_className: (0, $cYn9G.classNames)(/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports), "spectrum-Dialog-buttonGroup", {
                    "spectrum-Dialog-buttonGroup--noFooter": !hasFooter
                }),
                align: "end"
            }
        }), [
        hasFooter,
        hasHeader,
        titleProps
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("section", {
        ...styleProps,
        ...dialogProps,
        className: (0, $cYn9G.classNames)(/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports), "spectrum-Dialog", {
            [`spectrum-Dialog--${sizeVariant}`]: sizeVariant,
            "spectrum-Dialog--dismissable": isDismissable
        }, styleProps.className),
        ref: domRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $ibAW5.Grid), {
        ref: gridRef,
        UNSAFE_className: /*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-grid"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $cYn9G.SlotProvider), {
        slots: slots
    }, children), isDismissable && (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $j951X.ActionButton), {
        UNSAFE_className: /*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports)["spectrum-Dialog-closeButton"],
        isQuiet: true,
        "aria-label": stringFormatter.format("dismiss"),
        onPress: onDismiss
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $fll6F.default), null))));
}
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 * Depending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.
 */ let $d5b93a24089dc4d8$export$3ddf2d174ce01153 = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).forwardRef($d5b93a24089dc4d8$var$$99cd51dc4eb569f7$var$Dialog);
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */ function $d5b93a24089dc4d8$var$$2a8395160fff9af3$var$AlertDialog(props, ref) {
    let { onClose: onClose = ()=>{} } = (0, $7eprg.useContext)($d5b93a24089dc4d8$var$$97b119e05830ea0d$export$8b93a07348a7730c) || {};
    let { variant: variant, children: children, primaryActionLabel: primaryActionLabel, secondaryActionLabel: secondaryActionLabel, cancelLabel: cancelLabel, autoFocusButton: autoFocusButton, title: title, isPrimaryActionDisabled: isPrimaryActionDisabled, isSecondaryActionDisabled: isSecondaryActionDisabled, onCancel: onCancel = ()=>{}, onPrimaryAction: onPrimaryAction = ()=>{}, onSecondaryAction: onSecondaryAction = ()=>{}, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(otherProps);
    let stringFormatter = (0, $dxdPm.useLocalizedStringFormatter)(/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$f3fff851f5cc5a1e$exports));
    let confirmVariant = "primary";
    if (variant) {
        if (variant === "confirmation") confirmVariant = "cta";
        else if (variant === "destructive") confirmVariant = "negative";
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($d5b93a24089dc4d8$export$3ddf2d174ce01153, {
        UNSAFE_style: styleProps.style,
        UNSAFE_className: (0, $cYn9G.classNames)(/*@__PURE__*/ $d5b93a24089dc4d8$var$$parcel$interopDefault($d5b93a24089dc4d8$var$$78859b019f1ff3c5$exports), {
            [`spectrum-Dialog--${variant}`]: variant
        }, styleProps.className),
        isHidden: styleProps.hidden,
        size: "M",
        role: "alertdialog",
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $9JR01.Heading), null, title), (variant === "error" || variant === "warning") && (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $beEZ9.default), {
        slot: "typeIcon",
        "aria-label": stringFormatter.format("alert")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $bDtnO.Divider), null), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $5yq5x.Content), null, children), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $l1Yqs.ButtonGroup), {
        align: "end"
    }, cancelLabel && (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $j951X.Button), {
        variant: "secondary",
        onPress: ()=>(0, $5mLCk.chain)(onClose(), onCancel()),
        autoFocus: autoFocusButton === "cancel"
    }, cancelLabel), secondaryActionLabel && (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $j951X.Button), {
        variant: "secondary",
        onPress: ()=>(0, $5mLCk.chain)(onClose(), onSecondaryAction()),
        isDisabled: isSecondaryActionDisabled,
        autoFocus: autoFocusButton === "secondary"
    }, secondaryActionLabel), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $j951X.Button), {
        variant: confirmVariant,
        onPress: ()=>(0, $5mLCk.chain)(onClose(), onPrimaryAction()),
        isDisabled: isPrimaryActionDisabled,
        autoFocus: autoFocusButton === "primary"
    }, primaryActionLabel)));
}
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */ let $d5b93a24089dc4d8$export$de466dd8317b0b75 = (0, $7eprg.forwardRef)($d5b93a24089dc4d8$var$$2a8395160fff9af3$var$AlertDialog);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$DialogTrigger(props) {
    let { children: children, type: type = "modal", mobileType: mobileType = type === "popover" ? "modal" : type, hideArrow: hideArrow, targetRef: targetRef, isDismissable: isDismissable, isKeyboardDismissDisabled: isKeyboardDismissDisabled, ...positionProps } = props;
    if (!Array.isArray(children) || children.length > 2) throw new Error("DialogTrigger must have exactly 2 children");
    // if a function is passed as the second child, it won't appear in toArray
    let [trigger, content] = children;
    // On small devices, show a modal or tray instead of a popover.
    let isMobile = (0, $cYn9G.useIsMobileDevice)();
    if (isMobile) {
        // handle cases where desktop popovers need a close button for the mobile modal view
        if (type !== "modal" && mobileType === "modal") isDismissable = true;
        type = mobileType;
    }
    let state = (0, $1yMrW.useOverlayTriggerState)(props);
    let wasOpen = (0, $7eprg.useRef)(false);
    (0, $7eprg.useEffect)(()=>{
        wasOpen.current = state.isOpen;
    }, [
        state.isOpen
    ]);
    let isExiting = (0, $7eprg.useRef)(false);
    let onExiting = ()=>isExiting.current = true;
    let onExited = ()=>isExiting.current = false;
    (0, $7eprg.useEffect)(()=>{
        return ()=>{
            if ((wasOpen.current || isExiting.current) && type !== "popover" && type !== "tray") console.warn("A DialogTrigger unmounted while open. This is likely due to being placed within a trigger that unmounts or inside a conditional. Consider using a DialogContainer instead.");
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (type === "popover") return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$PopoverTrigger, {
        ...positionProps,
        state: state,
        targetRef: targetRef,
        trigger: trigger,
        content: content,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        hideArrow: hideArrow
    });
    let renderOverlay = ()=>{
        switch(type){
            case "fullscreen":
            case "fullscreenTakeover":
            case "modal":
                return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $6olJd.Modal), {
                    state: state,
                    isDismissable: type === "modal" ? isDismissable : false,
                    type: type,
                    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
                    onExiting: onExiting,
                    onExited: onExited
                }, typeof content === "function" ? content(state.close) : content);
            case "tray":
                return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $6olJd.Tray), {
                    state: state,
                    isKeyboardDismissDisabled: isKeyboardDismissDisabled
                }, typeof content === "function" ? content(state.close) : content);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$DialogTriggerBase, {
        type: type,
        state: state,
        isDismissable: isDismissable,
        trigger: trigger,
        overlay: renderOverlay()
    });
}
// Support DialogTrigger inside components using CollectionBuilder.
$d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$DialogTrigger.getCollectionNode = function*(props) {
    // @ts-ignore - seems like types are wrong. Function children work fine.
    let [trigger] = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).Children.toArray(props.children);
    let [, content] = props.children;
    yield {
        element: trigger,
        wrapper: (element)=>(0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$DialogTrigger, {
                key: element.key,
                ...props
            }, element, content)
    };
};
/**
 * DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's
 * open state with the trigger's press state. Additionally, it allows you to customize the type and
 * positioning of the Dialog.
 */ // We don't want getCollectionNode to show up in the type definition
let $d5b93a24089dc4d8$export$2e1e1122cf0cba88 = $d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$DialogTrigger;
function $d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$PopoverTrigger({ state: state, targetRef: targetRef, trigger: trigger, content: content, hideArrow: hideArrow, ...props }) {
    let triggerRef = (0, $7eprg.useRef)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $20dvM.useOverlayTrigger)({
        type: "dialog"
    }, state, triggerRef);
    let triggerPropsWithRef = {
        ...triggerProps,
        ref: targetRef ? undefined : triggerRef
    };
    let overlay = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $6olJd.Popover), {
        ...props,
        hideArrow: hideArrow,
        triggerRef: targetRef || triggerRef,
        state: state
    }, typeof content === "function" ? content(state.close) : content);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$DialogTriggerBase, {
        type: "popover",
        state: state,
        triggerProps: triggerPropsWithRef,
        dialogProps: overlayProps,
        trigger: trigger,
        overlay: overlay
    });
}
function $d5b93a24089dc4d8$var$$c412c5ea680c1e4f$var$DialogTriggerBase({ type: type, state: state, isDismissable: isDismissable, dialogProps: dialogProps = {}, triggerProps: triggerProps = {}, overlay: overlay, trigger: trigger }) {
    let context = {
        type: type,
        onClose: state.close,
        isDismissable: isDismissable,
        ...dialogProps
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $7eprg.Fragment), null, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $aCJeV.PressResponder), {
        ...triggerProps,
        onPress: state.toggle,
        isPressed: state.isOpen && type !== "modal" && type !== "fullscreen" && type !== "fullscreenTakeover"
    }, trigger), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($d5b93a24089dc4d8$var$$97b119e05830ea0d$export$8b93a07348a7730c.Provider, {
        value: context
    }, overlay));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d5b93a24089dc4d8$export$547754aada6e339f(props) {
    let { children: children, type: type = "modal", onDismiss: onDismiss, isDismissable: isDismissable, isKeyboardDismissDisabled: isKeyboardDismissDisabled } = props;
    let childArray = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).Children.toArray(children);
    if (childArray.length > 1) throw new Error("Only a single child can be passed to DialogContainer.");
    let [lastChild, setLastChild] = (0, $7eprg.useState)(null);
    // React.Children.toArray mutates the children, and we need them to be stable
    // between renders so that the lastChild comparison works.
    let child = null;
    if (Array.isArray(children)) child = children.find((0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).isValidElement);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).isValidElement(children)) child = children;
    if (child && child !== lastChild) setLastChild(child);
    let context = {
        type: type,
        onClose: onDismiss,
        isDismissable: isDismissable
    };
    let state = (0, $1yMrW.useOverlayTriggerState)({
        isOpen: !!child,
        onOpenChange: (isOpen)=>{
            if (!isOpen) onDismiss();
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $6olJd.Modal), {
        state: state,
        type: type,
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($d5b93a24089dc4d8$var$$97b119e05830ea0d$export$8b93a07348a7730c.Provider, {
        value: context
    }, lastChild));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d5b93a24089dc4d8$export$a2f2d8fa6720dab1() {
    let context = (0, $7eprg.useContext)($d5b93a24089dc4d8$var$$97b119e05830ea0d$export$8b93a07348a7730c);
    if (!context) throw new Error("Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.");
    return {
        type: context.type,
        dismiss () {
            context.onClose();
        }
    };
}

});
parcelRegister("beEZ9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $82e0cb5e229a6ff0$export$1e511d4a378977f5; }, function (v) { return $82e0cb5e229a6ff0$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $82e0cb5e229a6ff0$export$2e2bcd8739ae039; }, function (v) { return $82e0cb5e229a6ff0$export$2e2bcd8739ae039 = v; });
var $82e0cb5e229a6ff0$export$1e511d4a378977f5;
var $82e0cb5e229a6ff0$export$2e2bcd8739ae039;
"use strict";

var $l4FIw = parcelRequire("l4FIw");
$82e0cb5e229a6ff0$export$1e511d4a378977f5 = true;
$82e0cb5e229a6ff0$export$2e2bcd8739ae039 = $82e0cb5e229a6ff0$var$AlertMedium;

var $82e0cb5e229a6ff0$var$_extends2 = $l4FIw((parcelRequire("5WrMC")));

var $jqBnv = parcelRequire("jqBnv");

var $llVqi = parcelRequire("llVqi");

var $jxYT9 = parcelRequire("jxYT9");

var $82e0cb5e229a6ff0$var$_react = $l4FIw((parcelRequire("7eprg")));
const $82e0cb5e229a6ff0$var$ExpressIcon = (props)=>/*#__PURE__*/ $82e0cb5e229a6ff0$var$_react.default.createElement("svg", (0, $82e0cb5e229a6ff0$var$_extends2.default)({
        viewBox: "0 0 18 18"
    }, props), /*#__PURE__*/ $82e0cb5e229a6ff0$var$_react.default.createElement("path", {
        d: "M9 10.5a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v4.5a1 1 0 0 1-1 1Zm0 1.25A1.25 1.25 0 1 0 10.25 13 1.25 1.25 0 0 0 9 11.75Zm8.497 3.589a3.49 3.49 0 0 0 .079-3.474L12 1.815a3.385 3.385 0 0 0-5.994-.007L.416 11.88a3.485 3.485 0 0 0 .089 3.459A3.375 3.375 0 0 0 3.416 17h11.169a3.375 3.375 0 0 0 2.912-1.661ZM10.244 2.77l5.575 10.05a1.497 1.497 0 0 1-.037 1.489 1.374 1.374 0 0 1-1.197.69H3.416a1.374 1.374 0 0 1-1.197-.69 1.493 1.493 0 0 1-.046-1.474l5.593-10.08a1.386 1.386 0 0 1 2.478.015Z"
    }));
$82e0cb5e229a6ff0$var$ExpressIcon.displayName = $jqBnv.AlertMedium.displayName;
function $82e0cb5e229a6ff0$var$AlertMedium(props) {
    var _provider$theme, _provider$theme$globa;
    let provider = (0, $jxYT9.useProvider)();
    return /*#__PURE__*/ $82e0cb5e229a6ff0$var$_react.default.createElement($llVqi.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/ $82e0cb5e229a6ff0$var$_react.default.createElement($82e0cb5e229a6ff0$var$ExpressIcon, null) : /*#__PURE__*/ $82e0cb5e229a6ff0$var$_react.default.createElement($jqBnv.AlertMedium, null));
}

});
parcelRegister("l4FIw", function(module, exports) {
function $f57a54d42741b8b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $f57a54d42741b8b9$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jqBnv", function(module, exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AlertMedium = $e24d708880143015$var$AlertMedium;

var $e24d708880143015$var$_react = $e24d708880143015$var$_interopRequireDefault((parcelRequire("7eprg")));
function $e24d708880143015$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e24d708880143015$var$_extends() {
    $e24d708880143015$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e24d708880143015$var$_extends.apply(this, arguments);
}
function $e24d708880143015$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e24d708880143015$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e24d708880143015$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e24d708880143015$var$AlertMedium(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = $e24d708880143015$var$_objectWithoutProperties(_ref, [
        "scale"
    ]);
    return $e24d708880143015$var$_react["default"].createElement("svg", $e24d708880143015$var$_extends({}, props, props), scale === "L" && $e24d708880143015$var$_react["default"].createElement("path", {
        d: "M10.563 2.206l-9.249 16.55a.5.5 0 0 0 .436.744h18.5a.5.5 0 0 0 .436-.744l-9.251-16.55a.5.5 0 0 0-.872 0zm1.436 15.044a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25zm0-3.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25z"
    }), scale === "M" && $e24d708880143015$var$_react["default"].createElement("path", {
        d: "M8.564 1.289L.2 16.256A.5.5 0 0 0 .636 17h16.728a.5.5 0 0 0 .436-.744L9.436 1.289a.5.5 0 0 0-.872 0zM10 14.75a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25zm0-3a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25z"
    }));
}
$e24d708880143015$var$AlertMedium.displayName = "AlertMedium";

});


parcelRegister("l1Yqs", function(module, exports) {

$parcel$export(module.exports, "ButtonGroup", function () { return $f4f89044d15da5a0$export$69b1032f2ecdf404; });


var $cYn9G = parcelRequire("cYn9G");
var $5mLCk = parcelRequire("5mLCk");

var $5mLCk = parcelRequire("5mLCk");

var $jxYT9 = parcelRequire("jxYT9");

var $7eprg = parcelRequire("7eprg");
function $f4f89044d15da5a0$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $f4f89044d15da5a0$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f4f89044d15da5a0$var$$fddc5368d2db28a6$exports = {};
$f4f89044d15da5a0$var$$parcel$export($f4f89044d15da5a0$var$$fddc5368d2db28a6$exports, "spectrum-ButtonGroup", ()=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$a92faf51352ac608, (v)=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$a92faf51352ac608 = v);
$f4f89044d15da5a0$var$$parcel$export($f4f89044d15da5a0$var$$fddc5368d2db28a6$exports, "spectrum-ButtonGroup--alignCenter", ()=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$252bc7c4ae05757, (v)=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$252bc7c4ae05757 = v);
$f4f89044d15da5a0$var$$parcel$export($f4f89044d15da5a0$var$$fddc5368d2db28a6$exports, "spectrum-ButtonGroup--alignEnd", ()=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$30e96c53d7beca11, (v)=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$30e96c53d7beca11 = v);
$f4f89044d15da5a0$var$$parcel$export($f4f89044d15da5a0$var$$fddc5368d2db28a6$exports, "spectrum-ButtonGroup--vertical", ()=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$84d9c0e1917a4eaf, (v)=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$84d9c0e1917a4eaf = v);
$f4f89044d15da5a0$var$$parcel$export($f4f89044d15da5a0$var$$fddc5368d2db28a6$exports, "spectrum-ButtonGroup-Button", ()=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$7184de2337c1927f, (v)=>$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$7184de2337c1927f = v);
var $f4f89044d15da5a0$var$$fddc5368d2db28a6$export$a92faf51352ac608;
var $f4f89044d15da5a0$var$$fddc5368d2db28a6$export$252bc7c4ae05757;
var $f4f89044d15da5a0$var$$fddc5368d2db28a6$export$30e96c53d7beca11;
var $f4f89044d15da5a0$var$$fddc5368d2db28a6$export$84d9c0e1917a4eaf;
var $f4f89044d15da5a0$var$$fddc5368d2db28a6$export$7184de2337c1927f;
$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$a92faf51352ac608 = `aaz5ma_spectrum-ButtonGroup`;
$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$252bc7c4ae05757 = `aaz5ma_spectrum-ButtonGroup--alignCenter`;
$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$30e96c53d7beca11 = `aaz5ma_spectrum-ButtonGroup--alignEnd`;
$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$84d9c0e1917a4eaf = `aaz5ma_spectrum-ButtonGroup--vertical`;
$f4f89044d15da5a0$var$$fddc5368d2db28a6$export$7184de2337c1927f = `aaz5ma_spectrum-ButtonGroup-Button`;
function $f4f89044d15da5a0$var$$bd4bfa55854eb3bf$var$ButtonGroup(props, ref) {
    let { scale: scale } = (0, $jxYT9.useProvider)();
    props = (0, $jxYT9.useProviderProps)(props);
    props = (0, $cYn9G.useSlotProps)(props, "buttonGroup");
    let { children: children, orientation: orientation = "horizontal", isDisabled: isDisabled, align: align = "start", ...otherProps } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(otherProps);
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    let [hasOverflow, setHasOverflow] = (0, $5mLCk.useValueEffect)(false);
    let checkForOverflow = (0, $7eprg.useCallback)(()=>{
        let computeHasOverflow = ()=>{
            if (domRef.current && orientation === "horizontal") {
                let buttonGroupChildren = Array.from(domRef.current.children);
                let maxX = domRef.current.offsetWidth + 1; // + 1 to account for rounding errors
                // If any buttons have negative X positions (align="end") or extend beyond
                // the width of the button group (align="start"), then switch to vertical.
                if (buttonGroupChildren.some((child)=>child.offsetLeft < 0 || child.offsetLeft + child.offsetWidth > maxX)) return true;
                return false;
            }
        };
        if (orientation === "horizontal") setHasOverflow(function*() {
            // Force to horizontal for measurement.
            yield false;
            // Measure, and update if there is overflow.
            yield computeHasOverflow();
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef,
        orientation,
        scale,
        setHasOverflow,
        children
    ]);
    (0, $5mLCk.useLayoutEffect)(()=>{
        checkForOverflow();
    }, [
        checkForOverflow
    ]);
    // 2. External changes: buttongroup won't change size due to any parents changing size, so listen to its container for size changes to figure out if we should remeasure
    let parent = (0, $7eprg.useRef)();
    (0, $5mLCk.useLayoutEffect)(()=>{
        if (domRef.current) parent.current = domRef.current.parentElement;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef.current
    ]);
    (0, $5mLCk.useResizeObserver)({
        ref: parent,
        onResize: checkForOverflow
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        ...(0, $5mLCk.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef,
        className: (0, $cYn9G.classNames)(/*@__PURE__*/ $f4f89044d15da5a0$var$$parcel$interopDefault($f4f89044d15da5a0$var$$fddc5368d2db28a6$exports), "spectrum-ButtonGroup", {
            "spectrum-ButtonGroup--vertical": orientation === "vertical" || hasOverflow,
            "spectrum-ButtonGroup--alignEnd": align === "end",
            "spectrum-ButtonGroup--alignCenter": align === "center"
        }, styleProps.className)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $cYn9G.SlotProvider), {
        slots: {
            button: {
                UNSAFE_className: (0, $cYn9G.classNames)(/*@__PURE__*/ $f4f89044d15da5a0$var$$parcel$interopDefault($f4f89044d15da5a0$var$$fddc5368d2db28a6$exports), "spectrum-ButtonGroup-Button")
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $jxYT9.Provider), {
        isDisabled: isDisabled
    }, children)));
}
/**
 * ButtonGroup handles overflow for a grouping of buttons whose actions are related to each other.
 */ let $f4f89044d15da5a0$export$69b1032f2ecdf404 = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).forwardRef($f4f89044d15da5a0$var$$bd4bfa55854eb3bf$var$ButtonGroup);

});

parcelRegister("5yq5x", function(module, exports) {

$parcel$export(module.exports, "View", function () { return $40b45d57861e4c1e$export$27a5bd065ad55220; });
$parcel$export(module.exports, "Content", function () { return $40b45d57861e4c1e$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Footer", function () { return $40b45d57861e4c1e$export$a06f1c675e846f6f; });
$parcel$export(module.exports, "Header", function () { return $40b45d57861e4c1e$export$8b251419efc915eb; });

var $cYn9G = parcelRequire("cYn9G");

var $5mLCk = parcelRequire("5mLCk");

var $7eprg = parcelRequire("7eprg");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $40b45d57861e4c1e$var$$b9606c0c41d55371$var$View(props, ref) {
    props = (0, $cYn9G.useSlotProps)(props);
    let { elementType: ElementType = "div", children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(props, (0, $cYn9G.viewStyleProps));
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement(ElementType, {
        ...(0, $5mLCk.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $cYn9G.ClearSlots), null, children));
}
/**
 * View is a general purpose container with no specific semantics that can be used for custom styling purposes.
 * It supports Spectrum style props to ensure consistency with other Spectrum components.
 */ const $40b45d57861e4c1e$export$27a5bd065ad55220 = (0, $7eprg.forwardRef)($40b45d57861e4c1e$var$$b9606c0c41d55371$var$View);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $40b45d57861e4c1e$var$$0a7c18a2ef74b280$var$Content(props, ref) {
    props = (0, $cYn9G.useSlotProps)(props, "content");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(otherProps);
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("section", {
        ...(0, $5mLCk.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $cYn9G.ClearSlots), null, children));
}
/**
 * Content represents the primary content within a Spectrum container.
 */ const $40b45d57861e4c1e$export$7c6e2c02157bb7d2 = (0, $7eprg.forwardRef)($40b45d57861e4c1e$var$$0a7c18a2ef74b280$var$Content);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $40b45d57861e4c1e$var$$8d68cc89c1f9278e$var$Footer(props, ref) {
    props = (0, $cYn9G.useSlotProps)(props, "footer");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(otherProps);
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("footer", {
        ...(0, $5mLCk.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $cYn9G.ClearSlots), null, children));
}
/**
 * Footer represents a footer within a Spectrum container.
 */ const $40b45d57861e4c1e$export$a06f1c675e846f6f = (0, $7eprg.forwardRef)($40b45d57861e4c1e$var$$8d68cc89c1f9278e$var$Footer);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $40b45d57861e4c1e$var$$aedcc4886d2a392a$var$Header(props, ref) {
    props = (0, $cYn9G.useSlotProps)(props, "header");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(otherProps);
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("header", {
        ...(0, $5mLCk.filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $cYn9G.ClearSlots), null, children));
}
/**
 * Header represents a header within a Spectrum container.
 */ const $40b45d57861e4c1e$export$8b251419efc915eb = (0, $7eprg.forwardRef)($40b45d57861e4c1e$var$$aedcc4886d2a392a$var$Header);

});

parcelRegister("bDtnO", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $878a2119691cf491$export$2e0a83ec2e27ecbb; });


var $cYn9G = parcelRequire("cYn9G");

var $7eprg = parcelRequire("7eprg");

var $7vJuR = parcelRequire("7vJuR");
function $878a2119691cf491$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $878a2119691cf491$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $878a2119691cf491$var$$7a9eac509b76fa30$exports = {};
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "focus-ring", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$f39a09f249340e2a, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$f39a09f249340e2a = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "i18nFontFamily", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$8c4ee2c50c22c514, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$8c4ee2c50c22c514 = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-FocusRing-ring", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$4109102f950813a6, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$4109102f950813a6 = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-FocusRing", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$24c7f46a6e3605dd, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$24c7f46a6e3605dd = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-FocusRing--quiet", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$2927016961429360, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$2927016961429360 = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-Rule", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$9ebf9cdaed6878bc, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$9ebf9cdaed6878bc = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-Rule--horizontal", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$563c1b24466c05b8, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$563c1b24466c05b8 = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-Rule--large", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$243baa0ec4ab58cc, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$243baa0ec4ab58cc = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-Rule--medium", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$a8d73b58ca350eb9, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$a8d73b58ca350eb9 = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-Rule--small", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$b4b727880cfe37d, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$b4b727880cfe37d = v);
$878a2119691cf491$var$$parcel$export($878a2119691cf491$var$$7a9eac509b76fa30$exports, "spectrum-Rule--vertical", ()=>$878a2119691cf491$var$$7a9eac509b76fa30$export$76f93463a8fc15a8, (v)=>$878a2119691cf491$var$$7a9eac509b76fa30$export$76f93463a8fc15a8 = v);
var $878a2119691cf491$var$$7a9eac509b76fa30$export$f39a09f249340e2a;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$8c4ee2c50c22c514;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$4109102f950813a6;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$24c7f46a6e3605dd;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$2927016961429360;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$9ebf9cdaed6878bc;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$563c1b24466c05b8;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$243baa0ec4ab58cc;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$a8d73b58ca350eb9;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$b4b727880cfe37d;
var $878a2119691cf491$var$$7a9eac509b76fa30$export$76f93463a8fc15a8;
$878a2119691cf491$var$$7a9eac509b76fa30$export$f39a09f249340e2a = `cTbPrq_focus-ring`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$8c4ee2c50c22c514 = `cTbPrq_i18nFontFamily`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$4109102f950813a6 = `cTbPrq_spectrum-FocusRing-ring`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$24c7f46a6e3605dd = `cTbPrq_spectrum-FocusRing ${$878a2119691cf491$var$$7a9eac509b76fa30$export$4109102f950813a6}`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$2927016961429360 = `cTbPrq_spectrum-FocusRing--quiet`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$9ebf9cdaed6878bc = `cTbPrq_spectrum-Rule`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$563c1b24466c05b8 = `cTbPrq_spectrum-Rule--horizontal`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$243baa0ec4ab58cc = `cTbPrq_spectrum-Rule--large`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$a8d73b58ca350eb9 = `cTbPrq_spectrum-Rule--medium`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$b4b727880cfe37d = `cTbPrq_spectrum-Rule--small`;
$878a2119691cf491$var$$7a9eac509b76fa30$export$76f93463a8fc15a8 = `cTbPrq_spectrum-Rule--vertical`;
let $878a2119691cf491$var$$269e81ee206e9515$var$sizeMap = {
    S: "small",
    M: "medium",
    L: "large"
};
function $878a2119691cf491$var$$269e81ee206e9515$var$Divider(props, ref) {
    props = (0, $cYn9G.useSlotProps)(props, "divider");
    let { size: size = "L", orientation: orientation = "horizontal", ...otherProps } = props;
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(otherProps);
    let weight = $878a2119691cf491$var$$269e81ee206e9515$var$sizeMap[size];
    let Element = "hr";
    if (orientation === "vertical") Element = "div";
    let { separatorProps: separatorProps } = (0, $7vJuR.useSeparator)({
        ...props,
        elementType: Element
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement(Element, {
        ...styleProps,
        className: (0, $cYn9G.classNames)(/*@__PURE__*/ $878a2119691cf491$var$$parcel$interopDefault($878a2119691cf491$var$$7a9eac509b76fa30$exports), "spectrum-Rule", `spectrum-Rule--${weight}`, {
            "spectrum-Rule--vertical": orientation === "vertical",
            "spectrum-Rule--horizontal": orientation === "horizontal"
        }, styleProps.className),
        // @ts-ignore https://github.com/Microsoft/TypeScript/issues/28892
        ref: domRef,
        ...separatorProps
    });
}
/**
 * Dividers bring clarity to a layout by grouping and dividing content in close proximity.
 * They can also be used to establish rhythm and hierarchy.
 */ let $878a2119691cf491$export$2e0a83ec2e27ecbb = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).forwardRef($878a2119691cf491$var$$269e81ee206e9515$var$Divider);

});
parcelRegister("7vJuR", function(module, exports) {

$parcel$export(module.exports, "useSeparator", function () { return $577eb8618cf329da$export$52210f68a14655d0; });

var $5mLCk = parcelRequire("5mLCk");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $577eb8618cf329da$export$52210f68a14655d0(props) {
    let domProps = (0, $5mLCk.filterDOMProps)(props, {
        labelable: true
    });
    let ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === "vertical") ariaOrientation = "vertical";
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== "hr") return {
        separatorProps: {
            ...domProps,
            role: "separator",
            "aria-orientation": ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}

});


parcelRegister("fll6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b9307e07b7a9a9$export$2e2bcd8739ae039; }, function (v) { return $b2b9307e07b7a9a9$export$2e2bcd8739ae039 = v; });
var $b2b9307e07b7a9a9$export$1e511d4a378977f5;
var $b2b9307e07b7a9a9$export$2e2bcd8739ae039;
"use strict";

var $l4FIw = parcelRequire("l4FIw");
$b2b9307e07b7a9a9$export$1e511d4a378977f5 = true;
$b2b9307e07b7a9a9$export$2e2bcd8739ae039 = $b2b9307e07b7a9a9$var$CrossLarge;

var $giLar = parcelRequire("giLar");

var $llVqi = parcelRequire("llVqi");

var $b2b9307e07b7a9a9$var$_react = $l4FIw((parcelRequire("7eprg")));
function $b2b9307e07b7a9a9$var$CrossLarge(props) {
    return /*#__PURE__*/ $b2b9307e07b7a9a9$var$_react.default.createElement($llVqi.UIIcon, props, /*#__PURE__*/ $b2b9307e07b7a9a9$var$_react.default.createElement($giLar.CrossLarge, null));
}

});
parcelRegister("giLar", function(module, exports) {
/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CrossLarge = $bde2ea3f271656b6$var$CrossLarge;

var $bde2ea3f271656b6$var$_react = $bde2ea3f271656b6$var$_interopRequireDefault((parcelRequire("7eprg")));
function $bde2ea3f271656b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bde2ea3f271656b6$var$_extends() {
    $bde2ea3f271656b6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bde2ea3f271656b6$var$_extends.apply(this, arguments);
}
function $bde2ea3f271656b6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bde2ea3f271656b6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bde2ea3f271656b6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bde2ea3f271656b6$var$CrossLarge(_ref) {
    var _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? "M" : _ref$scale, props = $bde2ea3f271656b6$var$_objectWithoutProperties(_ref, [
        "scale"
    ]);
    return $bde2ea3f271656b6$var$_react["default"].createElement("svg", $bde2ea3f271656b6$var$_extends({}, props, props), scale === "L" && $bde2ea3f271656b6$var$_react["default"].createElement("path", {
        d: "M15.697 14.283L9.414 8l6.283-6.283A1 1 0 1 0 14.283.303L8 6.586 1.717.303A1 1 0 1 0 .303 1.717L6.586 8 .303 14.283a1 1 0 1 0 1.414 1.414L8 9.414l6.283 6.283a1 1 0 1 0 1.414-1.414z"
    }), scale === "M" && $bde2ea3f271656b6$var$_react["default"].createElement("path", {
        d: "M11.697 10.283L7.414 6l4.283-4.283A1 1 0 1 0 10.283.303L6 4.586 1.717.303A1 1 0 1 0 .303 1.717L4.586 6 .303 10.283a1 1 0 1 0 1.414 1.414L6 7.414l4.283 4.283a1 1 0 1 0 1.414-1.414z"
    }));
}
$bde2ea3f271656b6$var$CrossLarge.displayName = "CrossLarge";

});


parcelRegister("4O7mW", function(module, exports) {

$parcel$export(module.exports, "useDialog", function () { return $38018c3f3741d10d$export$d55e7ee900f34e93; });

var $5mLCk = parcelRequire("5mLCk");

var $8Snjw = parcelRequire("8Snjw");

var $7eprg = parcelRequire("7eprg");

var $20dvM = parcelRequire("20dvM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $38018c3f3741d10d$export$d55e7ee900f34e93(props, ref) {
    let { role: role = "dialog" } = props;
    let titleId = (0, $5mLCk.useSlotId)();
    titleId = props["aria-label"] ? undefined : titleId;
    let isRefocusing = (0, $7eprg.useRef)(false);
    (0, $7eprg.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $8Snjw.focusSafely)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    isRefocusing.current = true;
                    ref.current.blur();
                    (0, $8Snjw.focusSafely)(ref.current);
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $20dvM.useOverlayFocusContain)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $5mLCk.filterDOMProps)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            "aria-labelledby": props["aria-labelledby"] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}

});



//# sourceMappingURL=module.83dfa3fd.js.map
